import "./ErrorPage.css";

function SessionTO() {
  return (
    <div className="errMessege">
      <div>Session timed out or disconnected</div>
      <div>Please sing in again</div>
    </div>
  );
}

export default SessionTO;
